import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { fontColorDarkTheme } from '../../styles/global.styles';

export interface IRadioOptions {
  label: string;
  disabled?: boolean;
  value: string | number;
}

interface RadioSelectionComponentProps {
  options: IRadioOptions[];
  title?: string;
  value?: any;
  disabled?: boolean;
  onChange?: (value: any) => void;
}

const RadioSelectionComponent = ({
  options,
  title,
  value,
  disabled,
  onChange,
}: RadioSelectionComponentProps) => {
  return (
    <FormControl sx={{ pl: 1 }}>
      {title && (
        <FormLabel
          id="row-radio-buttons-group-label"
          sx={{ color: disabled ? 'rgb(96,96,96)' : fontColorDarkTheme }}
        >
          {title}
        </FormLabel>
      )}
      <RadioGroup
        row
        aria-labelledby="row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={value}
        onChange={({ target: { value } }) => onChange && onChange(value)}
      >
        {options.map((option, index) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            disabled={disabled ? true : option.disabled}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioSelectionComponent;
